(() => {
  // All reviews page (sections/all-reviews.liquid). Judge.me's public all_reviews_page widget returns 25 reviews
  // per page as HTML; we read the fields out of it and fill cards in the review carousel's style.
  const PAGE_URL = 'https://judge.me/api/v1/widgets/all_reviews_page';
  const COUNT_URL = 'https://judge.me/api/v1/widgets/all_reviews_count';

  const init = () => {
    document.querySelectorAll('[data-all-reviews]:not([data-ready])').forEach(setup);
  };

  const endpoint = (base, shop, token, params = {}) => {
    const url = new URL(base);
    url.searchParams.set('api_token', token);
    url.searchParams.set('shop_domain', shop);
    Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v));
    return url.toString();
  };

  const setup = (root) => {
    root.setAttribute('data-ready', '');
    const shop = root.dataset.judgemeShop;
    const token = root.dataset.judgemeToken;
    const list = root.querySelector('[data-all-reviews-list]');
    const status = root.querySelector('[data-all-reviews-status]');
    const more = root.querySelector('[data-all-reviews-more]');
    const moreButton = more?.querySelector('button');
    const cardTpl = root.querySelector('[data-all-reviews-card]');
    const starFull = root.querySelector('[data-judgeme-star-full]');
    const starEmpty = root.querySelector('[data-judgeme-star-empty]');
    const countEl = root.closest('.section-stack')?.querySelector('[data-all-reviews-count]');
    let page = 0;
    let total = 0;
    let shown = 0;
    let lastPageSize = 0;

    fetch(endpoint(COUNT_URL, shop, token))
      .then((r) => r.json())
      .then((d) => {
        total = Number(d.all_reviews_count) || 0;
        if (countEl && total) {
          countEl.textContent = `${total.toLocaleString('en-ZA')} reviews`;
          countEl.hidden = false;
        }
        toggleMore();
      })
      .catch(() => {});

    const toggleMore = () => {
      // A short page means the end even when the count call failed.
      if (more) more.hidden = !(lastPageSize === 25 && (!total || shown < total));
    };

    const load = async () => {
      if (moreButton) moreButton.disabled = true;
      try {
        const res = await fetch(endpoint(PAGE_URL, shop, token, { page: page + 1 }), { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        const reviews = parse(data.all_reviews || '');
        page += 1;
        reviews.forEach((r) => list.appendChild(card(r)));
        shown += reviews.length;
        lastPageSize = reviews.length;
        status.textContent = shown ? '' : 'No reviews yet.';
      } catch (err) {
        console.warn('[judgeme-all-reviews] fetch failed:', err);
        status.textContent = 'Reviews could not be loaded. Please refresh the page.';
      }
      if (moreButton) moreButton.disabled = false;
      toggleMore();
    };

    const card = (review) => {
      const node = cardTpl.content.firstElementChild.cloneNode(true);
      const ratingEl = node.querySelector('[data-rating-container]');
      const rating = Math.max(0, Math.min(5, Math.round(review.rating)));
      ratingEl.setAttribute('aria-label', `${rating} out of 5 stars`);
      for (let i = 1; i <= 5; i++) ratingEl.appendChild((i <= rating ? starFull : starEmpty).content.cloneNode(true));
      node.querySelector('[data-review-title]').textContent = review.title;
      node.querySelector('[data-review-body]').textContent = review.body;
      const nameEl = node.querySelector('[data-review-name]');
      // "Anonymous" is Judge.me's placeholder for a withheld name: hide the line rather than print the word.
      if (!review.name || /^anonymous$/i.test(review.name)) nameEl.remove();
      else nameEl.textContent = formatReviewer(review.name);
      const productEl = node.querySelector('[data-review-product]');
      if (review.product) {
        productEl.textContent = review.product;
        if (review.productUrl) productEl.href = review.productUrl;
      } else {
        productEl.parentElement.remove();
      }
      return node;
    };

    moreButton?.addEventListener('click', load);
    load();
  };

  const parse = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.from(doc.querySelectorAll('.jdgm-rev')).map((el) => {
      const link = el.querySelector('.jdgm-rev__prod-link');
      const href = link?.getAttribute('href') || '';
      return {
        rating: parseInt(el.querySelector('.jdgm-rev__rating')?.dataset.score, 10) || 0,
        title: (el.querySelector('.jdgm-rev__title')?.textContent || '').trim(),
        body: (el.querySelector('.jdgm-rev__body')?.textContent || '').trim(),
        name: (el.querySelector('.jdgm-rev__author')?.textContent || '').trim(),
        product: (link?.textContent || '').trim(),
        // Only same-store product paths become links.
        productUrl: href.startsWith('/products/') ? href : '',
      };
    });
  };

  const formatReviewer = (name) => {
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0];
    return `${parts[0]} ${parts[parts.length - 1][0].toUpperCase()}.`;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
